jQuery(document).ready(function ($) {

  window.oficina = {};
  window.oficina.time = Date.now();

  $('#oficina-mobi-close-button, #oficina-mobi-close').click(function(){
    $('#oficina-mobi-modal').remove();
    $('html, body').css({
      overflow: 'visible',
    });
    const time = Math.floor((Date.now() - window.oficina.time)/5000)*5;
    OficinaMobilidadeReadingTime(time);
  });


  const oficina_mobi_modal = $("#oficina-mobi-modal")
  const today              = new Date()
  const ms_per_day         = 1000 * 60 * 60 * 24;

  // var when_oficina_mobi_was_displayed = new Date(localStorage.getItem("when_oficina_mobi_was_displayed"));
  // var timer = ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) ? 10000 : 30000;

  // if ( (dateDiffInDays(when_oficina_mobi_was_displayed) >= 1 || when_oficina_mobi_was_displayed === null) ) {
  //   sessionStorage.setItem('restart-intervention', 'false')
  //   showOficinaMobilidade()

  //   var date = (today.getMonth() + 1) + "/" + today.getDate() + "/" + today.getFullYear()

  //   localStorage.setItem('when_oficina_mobi_was_displayed', date);
  // }


  function showOficinaMobilidade() {
    $('html, body').css({
      overflow: 'hidden',
    });
    oficina_mobi_modal.removeClass("d-none")
    oficina_mobi_modal.addClass("d-flex")


    window.timerOficinaMobilidade = setTimeout(timerOficinaMobilidade, timer)
    OficinaMobilidadeEventOpen();
  }

  showOficinaMobilidade();

  function dateDiffInDays(a) {

    const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    const utc2 = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());

    return Math.floor((utc2 - utc1) / ms_per_day);
  }

  $('.oficina-mobi-content').scroll(function (){

    clearTimeout(window.timerOficinaMobilidade);

    var height = $('.oficina-mobi-post ').height() - $('.oficina-mobi-content').height();

    if($(window).width()<768){
      $('.oficina-mobi-post ').height() + $('.col-md-4.bg-white.pb-5').height() - $('.oficina-mobi-content ').height() + 48
    }

    var percentage = Math.ceil($('.oficina-mobi-content').scrollTop() / height*5)*20;

    if(window.oficina.heights ==null) window.oficina.heights = [];

    if(!window.oficina.heights[percentage] && percentage<=100){
      OficinaMobilidadeReadingProgress(percentage);
    }

    window.oficina.heights[percentage] = true;

  })

  function timerOficinaMobilidade() {
    if( $(document).scrollTop() == 0 ) {
      $('#oficina-mobi-modal').remove();
      $('html, body').css({
        overflow: 'visible',
      });
    }
  }

});
